import React from 'react';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';

const ContactInformationPage = () => {
    return (
        <div className="flex flex-col min-h-screen bg-white text-gray-800">
            <NavBar />
            <main className="flex-1">
                <header className="bg-gray-50 border-b border-gray-200">
                    <div className="max-w-5xl mx-auto px-4 py-10">
                        <h1 className="text-3xl font-bold text-crumbblue">Contact Information</h1>
                        <p className="text-sm text-gray-600">
                            If you have any questions about CrumbCRM or your account, you can reach us at the email address below.
                        </p>
                    </div>
                </header>

                <div className="max-w-5xl mx-auto px-4 py-10 space-y-10 leading-7">
                    <section>
                        <h2 className="text-xl font-semibold text-crumbblue">How to Contact Us</h2>
                        <p className="mt-2">
                            For support, feedback, questions about your subscription, privacy inquiries, or anything else related to
                            CrumbCRM, please contact us by email:
                        </p>
                        <div className="mt-4 p-4 bg-gray-50 border border-gray-200 rounded-lg">
                            <p className="text-sm text-gray-700">Primary contact email:</p>
                            <p className="mt-1 text-lg font-semibold text-crumbblue break-all">
                                <a href="mailto:contact@crumb-crm.com" className="hover:underline">
                                    contact@crumb-crm.com
                                </a>
                            </p>
                        </div>
                        <p className="mt-4 text-sm text-gray-700">
                            When you reach out, please include any relevant details (such as the email associated with your CrumbCRM
                            account and a brief description of your question or issue) so that we can respond more quickly.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-crumbblue">Support & Response Times</h2>
                        <p className="mt-2">
                            CrumbCRM is a growing product, and we strive to respond to inquiries as soon as we reasonably can.
                            While we cannot guarantee specific response times, we aim to review all messages sent to{' '}
                            <span className="font-medium">contact@crumb-crm.com</span> in a timely manner.
                        </p>
                        <p className="mt-2 text-sm text-gray-700">
                            If your question relates to billing, service availability, or potential security concerns, please mention that
                            in the subject line of your email so we can prioritize it appropriately.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-crumbblue">Security & Privacy Notes</h2>
                        <p className="mt-2">
                            Please do not send sensitive personal information, full payment card numbers, or passwords in your email.
                            If we need additional details to help you, we will let you know what is required and how best to share it
                            safely.
                        </p>
                        <p className="mt-2 text-sm text-gray-700">
                            For more information about how we handle your data, you can review the CrumbCRM Privacy Policy from within
                            the app or on our website.
                        </p>
                    </section>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default ContactInformationPage;